<template>
    <div class="senior">
        <div class="imgDiv">
            <img src="../../assets/allsearch/logo.png" alt="" />
        </div>
        <div class="tsDiv" v-show="tsShow">
            <div class="adInfoDiv">{{ adInfo || "请输入检索式 比如 : (#1 OR #2) AND ((#3 OR #4) NOT #5)" }}</div>
            <!--  click=" tsShow = false; textVal = ''; " -->
            <!-- <button class="adBuleBtn" @click="editBtn">编辑</button> -->
            <van-button type="info" @click="editBtn">编辑</van-button>
        </div>
        <div class="textareaDiv" v-show="!tsShow">
            <!-- <textarea class="adJssTextarea" v-model="text" placeholder="请输入检索式"></textarea> -->
            <van-field v-model="text" rows="2" autosize type="textarea" placeholder="请输入检索式" show-word-limit
                class="adJssTextarea" minHeight="100" />
            <van-button type="info" class="adBuleBtn" @click="searchBtn">检索</van-button>
            <van-button type="info" class="adWhiteBtn" @click="text = ''">清除</van-button>
            <!-- adWhiteBtn  adBuleBtn -->
            <van-button type="info" class="adWhiteBtn" @click="tsShow = true">关闭</van-button>
        </div>
        <!-- <button @click="add">加1</button>
        <button @click="rem">减1</button> -->
        <condition v-for="(item, index) in num" :key="index" ref="con"></condition>
        <van-button type="info" @click="retrievalFun">检索</van-button>
    </div>
</template>

<script>
import { Toast } from "vant";
import condition from "./condition";
export default {
    data() {
        return {
            num: 5,
            tsShow: true,
            text: "",
            adInfo: ""
        };
    },
    created() { },
    mounted() {
        this.$store.dispatch("actionsHead", { type: false, title: "", iconType: false });
    },
    methods: {
        editBtn() {
            this.tsShow = false;
        },
        searchBtn() {
            if (this.text != '') {
                this.$router.push({ path: "/sList", query: { val: this.text } });
            } else {
                Toast("请输入检索式！");
            }

        },
        // 添加条件
        add() {
            this.num = this.num + 1;
        },
        // 删除条件
        rem() {
            if (this.num == 1) {
                alert("已经剩一条");
            } else {
                this.num = this.num - 1;
            }
        },
        // 检索
        retrievalFun() {
            // console.log(this.$refs.con);
            let params = {
                val: ""
            };
            let dom = this.$refs.con;
            for (let i = 0; i < dom.length; i++) {
                let gx = dom[i].$data.cValueKey;
                let tj = dom[i].$data.typeKey;
                let key = dom[i].$data.input;
                if (key) {
                    if (i == 0) {
                        params.val = "(" + key + "[" + tj + "])";
                    } else {
                        if (params.val) {
                            params.val = "(" + params.val + ") " + gx;
                        } else {
                            params.val = "";
                        }
                        //key中包含"[]"并且中括号内有值 不拼接条件
                        if (key.indexOf("[") > -1 && key.indexOf("]") > -1 && key.indexOf("]") - key.indexOf("[") > 1) {
                            params.val += " (" + key + ")";
                        } else {
                            params.val += " (" + key + "[" + tj + "])";
                        }
                    }
                }
            }
            this.adInfo = params.val;
            if (params.val != '') {
                this.$router.push({ path: "/sList", query: params });
            } else {
                Toast("请输入检索条件！");
            }
        }
    },
    components: {
        condition
    }
};
</script>
<style lang="less">
.senior {
    .imgDiv {
        background-color: #3187b6;
        text-align: center;

        img {
            width: 40%;
            margin: 1rem 0 0;
        }
    }

    .adInfoDiv {
        background-color: #fff;
        border: 0.05333rem solid #e9e9e9;
        min-height: 32px;
        width: 100%;
        padding: 5px 10px;
        color: #7f7e7e;
        line-height: 32px;
        display: inline-block;
        vertical-align: middle;
        word-break: break-all;
    }

    >.van-button {
        width: 80%;
        margin: 2rem auto;
        display: block;
        border-radius: 0.4rem;
    }

    .van-button {
        background: #3187b6;
        border-radius: 0.4rem;
        font-size: 1rem;
    }

    .tsDiv {
        padding: 1rem 0.5rem;

        .van-button {
            margin-top: 0.5rem;
            font-size: 0.8rem;
            height: 1.8rem;
        }
    }

    .textareaDiv {
        padding: 1rem 0.5rem;

        .van-button {
            margin-right: 0.4rem;
            margin-top: 0.5rem;
            font-size: 0.8rem;
            height: 1.8rem;
        }

        .adJssTextarea {
            font-size: 1rem;
            background-color: #fff;
            border: 0.05333rem solid #e9e9e9;
        }
    }

    .van-cell input {
        font-size: 1rem;
    }
}
</style>
